"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/contexts/authContext";

export function useAuthRedirect() {
  const { isAuthenticated, isInitialized } = useAuth();
  const [shouldRender, setShouldRender] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (isInitialized) {
      if (!isAuthenticated) {
        router.push("/login");
      } else {
        setShouldRender(true);
      }
    }
  }, [isInitialized, isAuthenticated, router]);

  return { isInitialized, shouldRender };
}
